import Edit from "@mui/icons-material/Edit";
import { useIntl } from "react-intl";
import { Link } from "react-router";

import { IconButton } from "@citrine/atoms/icon-button";

import { makeSvgIcon } from "./svg-icon";

export const EditIcon = makeSvgIcon(Edit);
export default EditIcon;

export function EditLink({
  to,
  size = "small",
}: {
  to: string;
  size?: "small" | "medium";
}) {
  const { formatMessage } = useIntl();

  return (
    <Link to={to}>
      <IconButton size={size} tooltip={formatMessage({ id: "Edit" })}>
        <EditIcon fontSize={size} />
      </IconButton>
    </Link>
  );
}
